import { track_ga } from '@/pages/firebase'

// 点击切换入口
export const trackClickLangEntry = (params) => {
  track_ga('region_click', { ...params })
}

// 切换成功
export const trackLangChanged = (params) => {
  track_ga('region_change', { ...params })
}
